import { CachedItem, storage } from "@lib-shared/lib";
import { appSettings } from "core/config";
import { Key, AllKeys } from "core/constants";
import { dateWrapper } from "./date.wrapper";

const cachedItemPrefix = "ci";

const logger = new CachedItem(Key.log, true, 0, false);

const _log = (...messages: any[]) => {
    const currentLogValue = logger.value;
    const currentLog = currentLogValue == null ? [] : currentLogValue;

    for (let i = 0; i < messages.length; i++) {
        currentLog.push(messages[i]);
    }

    logger.set(currentLog);
}

export const LocalStorageHelper = {
    logout() {
        //console.group();
        for (let i = 0; i < AllKeys.length; i++) {
            // console.log(`Removing ${allKeys[i]}`);
            storage.removeItem(AllKeys[i]);
        }
        //console.groupEnd();

        this.cleanUp();
        this.clearLog();
    },

    //Used for special debugging
    log(...args: any[]) {
        if (!appSettings.isEnabled.logToLocalStorage) {
            return;
        }

        _log(...args);
    },

    stampedLog(message: string) {
        if (!appSettings.isEnabled.logToLocalStorage) {
            return;
        }

        const timestamp = dateWrapper().timestamp;

        const msg = `[${timestamp}] ${message}`;
        this.log(msg);

        console.log(msg);
    },

    clearLog() {
        logger.clear();
    },

    //Removes all CachedItems with a prefix
    cleanUp() {
        const ls = window.localStorage;

        for (let i = 0; i < ls.length; i++) {
            const key = ls.key(i);
            if (key?.startsWith(cachedItemPrefix)) {
                // console.log(`Removing ${key}`);
                storage.removeItem(key);
            }
        }
    }
}

export default LocalStorageHelper;
